import React from 'react';
import {Helmet, translate} from 'views/module';
import DashboardView from 'views/scenes/dashboard/DashboardView';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>{translate('dashboard.Helmet.title')}</title>
      </Helmet>
      <DashboardView />
    </>
  );
};

export default App;
